/**
 * Created by Rodrigo Quesada on 21/12/16.
 */
import {Directive, Input} from '@angular/core';
import {AbstractControl, NG_VALIDATORS, Validators} from '@angular/forms';
import {CustomValidator, ValidationError} from '../custom-validator.class';
import {ValidationMessage} from '../form-validator.class';

@Directive({
    selector: '[myRequired]',
    providers: [{provide: NG_VALIDATORS, useExisting: MyRequiredValidatorDirective, multi: true}]
})
export class MyRequiredValidatorDirective implements CustomValidator {

    static ERROR_MESSAGE = new ValidationMessage('Field is required.', 'Save and complete later');

    @Input('myRequired') type: string;

    private get critical(): boolean {
        return this.type !== 'warn';
    }

    validate(control: AbstractControl) {
        // TODO report/fix Stream.collect/accumulator (using 'as any[]' as a temporary fix). This is an old comment...
        /*Stream.from(Object.keys(Validators.required(control)) as any[])
         .collect({
         supplier: () => ({}),
         accumulator: (acc, key) => {
         acc[key] = new ValidationError(MyRequiredValidatorDirective.ERROR_MESSAGE, this.critical);
         return acc;
         },
         finisher: r => r
         });*/

        let formErrors: {[key: string]: any} = Validators.required(control);
        if (formErrors) Object.keys(formErrors).forEach((key) => {
            formErrors[key] = new ValidationError(MyRequiredValidatorDirective.ERROR_MESSAGE, this.critical);
        });

        return formErrors;
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/components/forms/validation/required/required-validator.directive.ts